import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { STRINGS } from "@/i18n/strings";

const I18nContext = createContext(null);
const PREF_KEY = "ayndri_ui_language";

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = window.localStorage.getItem(PREF_KEY);
    return STRINGS[saved] ? saved : "en";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    window.localStorage.setItem(PREF_KEY, lang);
  }, [lang]);

  const t = useCallback((k) => STRINGS[lang]?.[k] ?? STRINGS.en[k] ?? k, [lang]);
  const setLang = (l) => { if (STRINGS[l]) setLangState(l); };

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
